import React from 'react';
import { compose } from 'redux';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import ProtectedRoute from 'hoc/ProtectedRoute';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { SideBarObjects } from 'components/pages/config/AdminSideBarObjects';
import PageTitle from 'hoc/PageTitle';
import BrandsTableContainer from 'containers/tables/BrandsTableContainer';
import { ADMINAREA_ACCESS } from 'constants/capabilities';

const ListBrandsPage = props => (
    <AdminTemplate
        header={<HeaderContainer admin />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer title="Brands" admin hideDatePicker />}>

        <BrandsTableContainer {...props} />
    </AdminTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'Brands', showGGBranding: true }),
    ProtectedRoute({ requiredCapabilities: [ADMINAREA_ACCESS] }),
)(ListBrandsPage);



// WEBPACK FOOTER //
// ./src/components/pages/admin/brands/ListBrands.js